import util from "../util/util";

const contentUrls = {
  returnCampaignListUrl: returnCampaignListUrl,
  returnCampaignDetailUrl: returnCampaignDetailUrl,
  returnCampaignFormUrl: returnCampaignFormUrl,
  returnChangeLogListUrl: returnChangeLogListUrl,
  returnChangeLogDetailUrl: returnChangeLogDetailUrl,
  returnConflictFormUrl: returnConflictFormUrl,
  returnInviteListUrl: returnInviteListUrl,
  returnInviteFormUrl: returnInviteFormUrl,
  returnLivestreamUrl: returnLivestreamUrl,
  returnPodListUrl: returnPodListUrl,
  returnPodDetailUrl: returnPodDetailUrl,
  returnPodFormUrl: returnPodFormUrl,
  returnReportsUrl: returnReportsUrl,
  returnRuleListUrl: returnRuleListUrl,
  returnRuleDetailUrl: returnRuleDetailUrl,
  returnRuleFormUrl: returnRuleFormUrl,
  returnScheduleWeekUrl: returnScheduleWeekUrl,
  returnScheduleDayUrl: returnScheduleDayUrl,
  returnScheduleTimeSlotUrl: returnScheduleTimeSlotUrl,
  returnSettingsUrl: returnSettingsUrl,
  returnSpotDetailUrl: returnSpotDetailUrl,
  returnSpotFormUrl: returnSpotFormUrl,
  returnSpotListUrl: returnSpotListUrl,
  returnUserListUrl: returnUserListUrl,
  returnUserFormUrl: returnUserFormUrl
};

export default contentUrls;

//

function returnCampaignListUrl(page = 1) {
  return `/campaigns/${page}/`;
}

function returnCampaignDetailUrl(id) {
  return `/campaign/${id}/`;
}

function returnCampaignFormUrl(campaignId = 0, podId) {
  let url = `/campaign/form/${campaignId}/`;

  if (podId) {
    url = `${url}pod/${podId}/`;
  }

  return url;
}

function returnChangeLogListUrl(page = 1) {
  return `/changelog/${page}/`;
}

function returnChangeLogDetailUrl(objType, id, page = 1) {
  const pathObj = util.returnChangeLogPath(objType);

  return `/changelog/${pathObj.path}/${id}/${page}/`;
}

function returnConflictFormUrl(count) {
  let url = `/conflicts/`;

  if (count) {
    url = `${url}${count}/`;
  }

  return url;
}

function returnInviteListUrl(page = 1) {
  return `/invites/${page}/`;
}

function returnInviteFormUrl(id = 0) {
  return `/invite/form/${id}/`;
}

function returnLivestreamUrl() {
  return `/livestream/`;
}

function returnPodListUrl(page = 1) {
  return `/pods/${page}/`;
}

function returnPodDetailUrl(id) {
  return `/pod/${id}/`;
}

function returnPodFormUrl(id = 0, spotId = null) {
  let url = `/pod/form/${id}/`;

  if (spotId) {
    url = `${url}spot/${spotId}/`;
  }

  return url;
}

function returnReportsUrl(page = 1) {
  return `/reports/${page}/`;
}

function returnRuleListUrl(page = 1) {
  return `/rules/${page}/`;
}

function returnRuleDetailUrl(id) {
  return `/rule/${id}/`;
}

function returnRuleFormUrl(ruleId = 0, podId, campaignId) {
  let url = `/rule/form/${ruleId}/`;

  if (podId) {
    url = `${url}pod/${podId}/`;
  } else if (campaignId) {
    url = `${url}campaign/${campaignId}/`;
  }

  return url;
}

function returnScheduleWeekUrl(day = util.returnSunday()) {
  return `/schedule/week/${day}/`;
}

function returnScheduleDayUrl(day = util.returnSunday()) {
  return `/schedule/day/${day}/`;
}

function returnScheduleTimeSlotUrl(timeslot, day) {
  return `/schedule/timeslot/${timeslot}/${day}/`;
}

function returnSettingsUrl() {
  return `/settings/`;
}

function returnSpotDetailUrl(id) {
  return `/spot/${id}/`;
}

function returnSpotFormUrl(id = 0) {
  return `/spot/form/${id}/`;
}

function returnSpotListUrl(page = 1) {
  return `/spots/${page}/`;
}

function returnUserListUrl(page = 1) {
  return `/users/${page}/`;
}

function returnUserFormUrl(id = 0) {
  return `/user/form/${id}/`;
}
